"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _AppSearch = _interopRequireDefault(require("./AppSearch"));

var _AppIdentifier = _interopRequireDefault(require("./AppIdentifier"));

var _AppSubview = _interopRequireDefault(require("./AppSubview"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: "100%",
    height: theme.spacing(8),
    overflow: "hidden"
  },
  identifer: {
    position: "relative",
    width: "100%",
    height: theme.spacing(8),
    marginTop: theme.spacing(-8),
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginTop: 0
    }
  },
  subview: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    position: "relative",
    width: "100%",
    height: theme.spacing(8),
    marginTop: theme.spacing(-8),
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginTop: 0
    }
  },
  growingSearch: {
    position: "absolute",
    right: 0,
    height: theme.spacing(5),
    margin: theme.spacing(1.5),
    borderRadius: theme.spacing(2.5),
    backgroundColor: "white",
    color: theme.palette.text.primary,
    display: "flex",
    justifyContent: "flex-start",
    width: theme.spacing(18),
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(5)
    },
    overflow: "hidden",
    transition: ".125s ease-out",
    "& input": {
      fontSize: "16px",
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(3),
      overflow: "hidden",
      textOverflow: "ellipsis",
      [theme.breakpoints.down('xs')]: {
        display: "none"
      },
      "& + button": {
        display: "none"
      }
    },
    "& button": {
      width: "100%",
      height: theme.spacing(6),
      borderRadius: theme.spacing(3),
      marginTop: theme.spacing(-.5),
      marginRight: theme.spacing(.5),
      marginBottom: theme.spacing(-.5),
      marginLeft: theme.spacing(.5),
      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(-.5)
      },
      display: "flex",
      justifyContent: "flex-start"
    },
    "&[aria-expanded=true]": {
      width: "100%",
      [theme.breakpoints.down('xs')]: {
        width: "100%"
      },
      height: theme.spacing(8),
      margin: 0,
      borderRadius: 0,
      "& button": {
        width: theme.spacing(6),
        height: theme.spacing(6),
        margin: theme.spacing(1)
      },
      "& input": {
        fontSize: "18px",
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
        [theme.breakpoints.down('xs')]: {
          display: "block"
        },
        "& + button": {
          display: "block"
        }
      }
    }
  },
  search: {
    position: "relative",
    width: "100%",
    height: theme.spacing(8),
    marginTop: 0,
    transition: ".125s ease-out",
    display: "flex",
    position: "relative",
    backgroundColor: "white",
    color: theme.palette.text.primary,
    width: "100%",
    height: theme.spacing(8),
    overflow: "hidden",
    fontFamily: "Akkurat, sans-serif",
    "&[aria-expanded=true]": {
      marginTop: theme.spacing(-8)
    }
  }
}));

const AppHeader = ({
  className,
  expanded = true,
  elevation = 2,
  color = "primary",
  title,
  subtitle,
  menu,
  search,
  subview,
  onToggle,
  children
}) => {
  const classes = useStyles({
    color
  });
  const classesSearch = search && search.variant === "grow" && classes.growingSearch || classes.search;
  const justifyContent = search && search.variant === "grow" && "flex-start" || "center";
  return _react.default.createElement(_AppBar.default, {
    position: "absolute",
    className: className || classes.root,
    component: "header",
    "aria-expanded": expanded,
    elevation: expanded && elevation
  }, _react.default.createElement(_AppSubview.default, _extends({}, subview, {
    className: classes.subview,
    expanded: subview && subview.expanded
  })), _react.default.createElement(_AppIdentifier.default, {
    className: classes.identifer,
    justifyContent: justifyContent,
    menu: menu,
    search: search,
    title: title,
    subtitle: subtitle,
    expanded: search && search.expanded && false || true,
    onToggle: onToggle
  }), search && !search.disabled && _react.default.createElement(_AppSearch.default, _extends({}, search, {
    className: classesSearch,
    expanded: search && search.expanded
  })), children);
};

AppHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  expanded: _propTypes.default.bool,
  elevation: _propTypes.default.number,
  color: _propTypes.default.string,
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  search: _propTypes.default.shape({
    expanded: _propTypes.default.bool,
    placeholder: _propTypes.default.string
  }),
  subview: _propTypes.default.shape({
    expanded: _propTypes.default.bool,
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string
  })
} : {};
var _default = AppHeader;
exports.default = _default;
module.exports = exports.default;